import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListLiveUsers from '../../components/reports/list-live-users.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ReportsLiveUsersView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_LIVE_USERS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListLiveUsers />
    </AppLayout>
  );
};

export default ReportsLiveUsersView;
